"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = _propTypes["default"].shape({
  trackEvent: _propTypes["default"].func,
  getTrackingData: _propTypes["default"].func
});
exports["default"] = _default;